import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 243.52 90.97"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "data-name": "Layer 2" }, [
  /*#__PURE__*/_createElementVNode("g", { "data-name": "Layer 1" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M241.52 16.5C241.52 8.49 233.23 2 223 2H20.53C10.3 2 2 8.49 2 16.49 2 24.5 10.3 31 20.53 31h40.33c10.23 0 18.53 6.49 18.53 14.5 0 8-8.3 14.49-18.53 14.49H44.92c-10.24 0-18.53 6.49-18.53 14.5 0 8 8.29 14.49 18.53 14.49h170.2c10.24 0 18.54-6.49 18.54-14.49s-8.3-14.5-18.54-14.5h-15.93c-10.24 0-18.54-6.49-18.54-14.49s8.3-14.5 18.54-14.5H223c10.23 0 18.52-6.5 18.52-14.5Z",
      "data-name": "Clouds",
      style: {"fill":"#fff7f3","stroke":"#2d2d34","stroke-miterlimit":"10","stroke-width":"2px"}
    })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }